import { createContext, useContext } from 'react';

/**
 * Identifies the current workpage for test-id composition. Set by
 * `Workpage` near the root of the tree (from `workpageDef.slug`) and
 * consumed by descendant widgets to scope their `data-testid` values.
 *
 * Empty string means "no scope" — descendant widgets will fall back to
 * unscoped test ids in that case.
 */
const WorkpageTestIdContext = createContext<string>('');

export default WorkpageTestIdContext;

/** Returns the current workpage test-id scope (empty string if none). */
export function useWorkpageTestIdScope(): string {
  return useContext(WorkpageTestIdContext);
}
